var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("header-country", {
        attrs: {
          link: _vm.banner.link,
          "open-link-in-new-tab": _vm.openLinkInNewTab,
          "country-code": _vm.countryCode,
          "url-key": _vm.urlKey,
          "caret-icon": _vm.caretIcon,
          "class-name": _vm.className,
          "enable-ga-event": _vm.enableGaEvent,
          body: _vm.banner.body
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }